import { Color } from '@nect/ui/theme/color';
import React from 'react';
import styled from 'styled-components';

import { Box } from '../box';
import { TextBodySmallCSS } from '../text/text.styled';

export interface ITagProps {
    /**
    Dot Color
    */
    dotColor?: Color;

    /**
    Add border to the component
    */
    hasBorder?: boolean;

    /**
    Content
    */
    content: string;

    /**
    Inline CSS style
    */
    style?: React.CSSProperties;

    /**
    onClick handler
    */
    onClick?: React.MouseEventHandler<HTMLDivElement>;
}

type ITagStyledProps = Omit<ITagProps, 'content'>;

const TagStyled = styled(Box)<ITagStyledProps>`
    ${TextBodySmallCSS}
    ${({ hasBorder }) => (!hasBorder ? 'border-color: transparent' : '')};
    ${({ onClick }) => (onClick ? 'cursor: pointer' : '')};
    background-color: ${({ theme }) => theme.color[Color.white100]};

    border-radius: ${({ theme }) => theme.borderRadius.M};

    padding: ${({ theme }) =>
        `calc(${theme.spacing.XXS} - 1px) calc(${theme.spacing.M} - 1px)`};

    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    min-height: 35px;

    &::before {
        content: '';
        border-radius: ${({ theme }) => theme.borderRadius.Round};
        background-color: ${({ theme, dotColor }) =>
            theme.color[dotColor ?? Color.grey700]};
        margin-right: ${({ theme }) => theme.spacing.XXS};

        padding: 3px;
        flex: 0 2 auto;
        display: inline-block;
    }
`;

export const Tag = ({
    dotColor,
    hasBorder,
    style,
    onClick,
    content,
}: ITagProps) => {
    return (
        <TagStyled
            dotColor={dotColor}
            hasBorder={hasBorder}
            borderSize={1}
            onClick={onClick}
            style={style}
            direction="row"
        >
            {content}
        </TagStyled>
    );
};
